export const SEMI_FINISHED_PROVIDER = 'OUTLABEL';

export const DATE_FORMAT = Object.freeze({
  BRAZILIAN: 'DD/MM/YY',
  BRAZILIAN_LETTERS: 'DD/MMM/YY',
  AMERICAN: 'MM/DD/YY'
})

export const NAVBAR_OPTIONS = Object.freeze({
  REQUEST_VIEW: { name: 'RequestView', displayName: 'Requisições', icon: 'mdi-notebook-edit-outline', displayOrder: 2 },
  APPROVAL_VIEW: { name: 'ApprovalView', displayName: 'Aprovações', icon: 'mdi-check-decagram', displayOrder: 3 },
  FINANCE_VIEW: { name: 'FinanceView', displayName: 'Financeiro', icon: 'mdi-cash-multiple', displayOrder: 4 },
  USER_VIEW: { name: 'UserView', displayName: 'Usuários', icon: 'mdi-account-group', displayOrder: 5 },
  GENERAL_VIEW: { name: 'GeneralView', displayName: 'Todas', icon: 'mdi-view-list', displayOrder: 1 }
})

export const USER_ROLE = Object.freeze({
  ADMIN: { id: "ADMIN", label: "Administrador" },
  GENERAL: { id: "GENERAL", label: "Geral" },
  PURCHASER: { id: "PURCHASER", label: "Comprador" },
  APPROVER: { id: "APPROVER", label: "Aprovador" },
  FINANCE: { id: "FINANCE", label: "Financeiro" }
})

export const REQUEST_STATUS = Object.freeze({
  PENDING: { label: "Pendente", color: "warning", id: "PENDING", nextStatus: "IN_PURCHASE", nextStatusLabel: "Em Compras" },
  IN_PURCHASE: { label: "Em Compras", color: "info", id: "IN_PURCHASE", nextStatus: "WAITING_APPROVAL", nextStatusLabel: "Aguardando Aprovação"  },
  WAITING_APPROVAL: { label: "Aguardando Aprovação", color: "primary", id: "WAITING_APPROVAL", nextStatus: "APPROVED", nextStatusLabel: "Aprovado"  },
  APPROVED: { label: "Aprovado", color: "success", id: "APPROVED", nextStatus: "DELIVERED", nextStatusLabel: "Entregue" },
  DENIED: { label: "Negado", color: "error", id: "DENIED", nextStatus: "RETURNED", nextStatusLabel: "Devolvido" },
  RETURNED: { label: "Devolvido", color: "warning", id: "RETURNED", nextStatus: "DELIVERED", nextStatusLabel: "Entregue" },
  DELIVERED: { label: "Entregue", color: "success", id: "DELIVERED", nextStatus: "COMPLETED", nextStatusLabel: "Concluído" },
  COMPLETED: { label: "Concluído", color: "success", id: "COMPLETED", nextStatus: null, nextStatusLabel: null }
})

export const PRIORITY_TYPES = Object.freeze({
  HIGH: { label: "URGENTE", color: "error", id: "HIGH" },
  MEDIUM: { label: "ALTA", color: "warning", id: "MEDIUM" },
  LOW: { label: "NORMAL", color: "success", id: "LOW" }
})

export const GENERAL_OPTIONS = Object.freeze({
  SECTOR: { label: "Setor", color: "info", id: "SECTOR" },
  PAYMENT_METHOD: { label: "Método de Pagamento", color: "warning", id: "PAYMENT_METHOD" },
  UNIT_TYPE: { label: "Unidade de Medida", color: "primary", id: "UNIT" },
  SUPPLIER: { label: "Fornecedor", color: "secondary", id: "SUPPLIER" }
})

export const PROD_SECTOR_ID = '8f11c3b3-786b-4235-a064-d6d78b714ac7';
export const PAYMENT_WARNING_METHOD_ID = 'edcfd242-423c-4ded-a797-a9271ccb2441';